<template>
  <div v-if="visible" class="fixed inset-0 z-70 overflow-y-auto bg-gray-900/60 backdrop-blur-sm">
    <!-- Overlay -->
    <div class="fixed inset-0 transition-opacity" @click="cerrarModal"></div>

    <!-- Modal Container -->
    <div class="flex min-h-full items-center justify-center p-4">
      <div class="relative bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] overflow-hidden">

        <!-- Header -->
        <div class="bg-white px-6 py-4 border-b border-gray-200">
          <div class="flex items-center justify-between">
            <h2 class="text-xl font-semibold text-gray-900">Gestión de Equipos</h2>
            <button @click="cerrarModal" class="p-2 hover:bg-gray-100 rounded-full transition-colors">
              <svg class="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
              </svg>
            </button>
          </div>
        </div>

        <!-- Content -->
        <div class="p-6 overflow-y-auto max-h-[calc(90vh-80px)]">

          <!-- Sección superior: Título y botón Agregar -->
          <div class="mb-6">
            <div class="flex items-center justify-between mb-4">
              <h3 class="text-lg font-medium text-gray-900">EQUIPO</h3>
              <button v-if="puedeCrearEquipo" class="bg-white text-center text-sm w-36 rounded-xl h-10 relative text-black font-medium group border border-indigo-600 transition-all duration-300 overflow-hidden">
                <div class="flex items-center justify-center h-full relative z-10 transition-all duration-300 group-hover:text-white">
                  <svg class="w-4 h-4 mr-1.5 transition-all duration-300 group-hover:scale-110" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
                  </svg>
                  <span>Crear Equipo</span>
                </div>
                <div class="absolute inset-0 bg-indigo-600 rounded-xl transform scale-x-0 origin-left group-hover:scale-x-100 transition-transform duration-300 ease-out"></div>
              </button>
            </div>
          </div>

          <!-- Grid de equipos -->
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">

            <!-- Tarjeta HVAC -->
            <div class="bg-white border-2 border-gray-200 rounded-lg p-6 hover:border-blue-300 transition-colors cursor-pointer group">
              <div class="text-center">
                <!-- Icono HVAC -->
                <div class="mb-4">
                  <div class="w-24 h-24 mx-auto bg-gray-100 rounded-lg flex items-center justify-center group-hover:bg-blue-50 transition-colors">
                    <!-- Icono de ventilador/HVAC -->
                    <svg class="w-16 h-16 text-gray-400 group-hover:text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 3v18m0-18l4 4m-4-4L8 7m4 14l4-4m-4 4l-4-4" />
                      <circle cx="12" cy="12" r="3" />
                    </svg>
                  </div>
                </div>

                <h4 class="text-lg font-semibold text-gray-900 mb-2">HVAC</h4>

                <!-- Iconos de acciones -->
                <div class="flex justify-center space-x-2 mt-4">
                  <button @click.stop="editarEquipo('hvac')" class="p-2 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors" title="Editar">
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
                    </svg>
                  </button>

                  <button @click.stop="duplicarEquipo('hvac')" class="p-2 text-gray-400 hover:text-green-600 hover:bg-green-50 rounded-lg transition-colors" title="Duplicar">
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"></path>
                    </svg>
                  </button>

                  <button @click.stop="eliminarEquipo('hvac')" class="p-2 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors" title="Eliminar">
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                    </svg>
                  </button>
                </div>
              </div>
            </div>

            <!-- Tarjeta CINTA TRANSPORTADORA -->
            <div class="bg-white border-2 border-gray-200 rounded-lg p-6 hover:border-blue-300 transition-colors cursor-pointer group">
              <div class="text-center">
                <!-- Icono Cinta Transportadora -->
                <div class="mb-4">
                  <div class="w-24 h-24 mx-auto bg-gray-100 rounded-lg flex items-center justify-center group-hover:bg-blue-50 transition-colors">
                    <!-- Icono de cinta transportadora -->
                    <svg class="w-16 h-16 text-gray-400 group-hover:text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <rect x="2" y="10" width="20" height="4" rx="2" stroke-width="1.5" />
                      <circle cx="6" cy="12" r="2" fill="currentColor" />
                      <circle cx="12" cy="12" r="2" fill="currentColor" />
                      <circle cx="18" cy="12" r="2" fill="currentColor" />
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M2 8h20M2 16h20" />
                    </svg>
                  </div>
                </div>

                <h4 class="text-lg font-semibold text-gray-900 mb-2">CINTA</h4>
                <h5 class="text-sm text-gray-600 mb-2">TRANSPORTADORA</h5>

                <!-- Iconos de acciones -->
                <div class="flex justify-center space-x-2 mt-4">
                  <button @click.stop="editarEquipo('cinta')" class="p-2 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors" title="Editar">
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
                    </svg>
                  </button>

                  <button @click.stop="duplicarEquipo('cinta')" class="p-2 text-gray-400 hover:text-green-600 hover:bg-green-50 rounded-lg transition-colors" title="Duplicar">
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"></path>
                    </svg>
                  </button>

                  <button @click.stop="eliminarEquipo('cinta')" class="p-2 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors" title="Eliminar">
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                    </svg>
                  </button>
                </div>
              </div>
            </div>

            <!-- Tarjeta COLECTOR DE POLVO -->
            <div class="bg-white border-2 border-gray-200 rounded-lg p-6 hover:border-blue-300 transition-colors cursor-pointer group">
              <div class="text-center">
                <!-- Icono Colector de Polvo -->
                <div class="mb-4">
                  <div class="w-24 h-24 mx-auto bg-gray-100 rounded-lg flex items-center justify-center group-hover:bg-blue-50 transition-colors">
                    <!-- Icono de colector de polvo -->
                    <svg class="w-16 h-16 text-gray-400 group-hover:text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M19 14l-7 7m0 0l-7-7m7 7V3" />
                      <rect x="8" y="15" width="8" height="6" rx="1" stroke-width="1.5" />
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16 15c0-4-4-8-4-8s-4 4-4 8" />
                    </svg>
                  </div>
                </div>

                <h4 class="text-lg font-semibold text-gray-900 mb-2">COLECTOR</h4>
                <h5 class="text-sm text-gray-600 mb-2">DE POLVO</h5>

                <!-- Iconos de acciones -->
                <div class="flex justify-center space-x-2 mt-4">
                  <button @click.stop="editarEquipo('colector')" class="p-2 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors" title="Editar">
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
                    </svg>
                  </button>

                  <button @click.stop="duplicarEquipo('colector')" class="p-2 text-gray-400 hover:text-green-600 hover:bg-green-50 rounded-lg transition-colors" title="Duplicar">
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"></path>
                    </svg>
                  </button>

                  <button @click.stop="eliminarEquipo('colector')" class="p-2 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors" title="Eliminar">
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                    </svg>
                  </button>
                </div>
              </div>
            </div>

          </div>
        </div>

        <!-- Footer -->
        <div class="bg-gray-50 px-6 py-4 border-t border-gray-200">
          <div class="flex justify-end space-x-3">
            <button @click="cerrarModal" class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PermissionsService from '@/services/auth/permissions.js'

export default {
  name: 'ModalGestionEquipos',

  components: {
  },

  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      mostrarModalCreacion: false,
      equipoEditando: null,
      modoModal: 'crear', // 'crear', 'editar', 'duplicar'
      equipos: [
        {
          id: 1,
          tipo: 'hvac',
          nombre: 'HVAC',
          descripcion: 'Sistema de calefacción, ventilación y aire acondicionado',
          configuracion: {}
        },
        {
          id: 2,
          tipo: 'cinta',
          nombre: 'CINTA TRANSPORTADORA',
          descripcion: 'Sistema de transporte mediante cinta',
          configuracion: {}
        },
        {
          id: 3,
          tipo: 'colector',
          nombre: 'COLECTOR DE POLVO',
          descripcion: 'Sistema de recolección de polvo y partículas',
          configuracion: {}
        }
      ]
    }
  },
  computed: {
    // ========================================
    // PERMISOS COMPUTADOS
    // ========================================
    puedeCrearEquipo() {
      this.permisosVersion
      return PermissionsService.can('equipos', 'crear')
    },
    // ========================================
  },

  mounted() {
    document.addEventListener('keydown', this.handleEscapeKey)
  },

  beforeUnmount() {
    document.removeEventListener('keydown', this.handleEscapeKey)
  },

  methods: {
    cerrarModal() {
      this.$emit('cerrar')
    },

    handleEscapeKey(event) {
      if (event.key === 'Escape' && this.visible && !this.mostrarModalCreacion) {
        this.cerrarModal()
      }
    },

    abrirModalCreacion() {
      this.modoModal = 'crear'
      this.equipoEditando = null
      this.mostrarModalCreacion = true
    },

    editarEquipo(tipoEquipo) {
      const equipo = this.equipos.find(e => e.tipo === tipoEquipo)
      if (equipo) {
        this.modoModal = 'editar'
        this.equipoEditando = { ...equipo }
        this.mostrarModalCreacion = true
        console.log(`Editando equipo: ${equipo.nombre}`)
      }
    },

    duplicarEquipo(tipoEquipo) {
      const equipo = this.equipos.find(e => e.tipo === tipoEquipo)
      if (equipo) {
        this.modoModal = 'duplicar'
        this.equipoEditando = {
          ...equipo,
          id: null,
          nombre: `${equipo.nombre} (Copia)`
        }
        this.mostrarModalCreacion = true
        console.log(`Duplicando equipo: ${equipo.nombre}`)
      }
    },

    eliminarEquipo(tipoEquipo) {
      const equipo = this.equipos.find(e => e.tipo === tipoEquipo)
      if (equipo && confirm(`¿Estás seguro de que deseas eliminar el equipo "${equipo.nombre}"?`)) {
        this.equipos = this.equipos.filter(e => e.tipo !== tipoEquipo)
        console.log(`Equipo eliminado: ${equipo.nombre}`)
        // Aquí harías la llamada a la API para eliminar
      }
    },

    cerrarModalCreacion() {
      this.mostrarModalCreacion = false
      this.equipoEditando = null
      this.modoModal = 'crear'
    },

    manejarEquipoGuardado(equipoData) {
      console.log('Equipo guardado:', equipoData)

      if (this.modoModal === 'crear' || this.modoModal === 'duplicar') {
        // Agregar nuevo equipo
        const nuevoEquipo = {
          id: Date.now(), // ID temporal
          ...equipoData
        }
        this.equipos.push(nuevoEquipo)
        console.log('Nuevo equipo agregado:', nuevoEquipo)

      } else if (this.modoModal === 'editar') {
        // Actualizar equipo existente
        const index = this.equipos.findIndex(e => e.id === this.equipoEditando.id)
        if (index !== -1) {
          this.equipos[index] = { ...this.equipos[index], ...equipoData }
          console.log('Equipo actualizado:', this.equipos[index])
        }
      }

      this.cerrarModalCreacion()

      // Aquí harías la llamada a la API para guardar los cambios
      this.$emit('equipo-actualizado', equipoData)
    }
  }
}
</script>

<style scoped>
/* Estilos adicionales si es necesario */
.transition-colors {
  transition: color 0.2s ease-in-out, background-color 0.2s ease-in-out, border-color 0.2s ease-in-out;
}

/* Hover effects para las tarjetas */
.group:hover .group-hover\:border-blue-300 {
  border-color: #93c5fd;
}

.group:hover .group-hover\:bg-blue-50 {
  background-color: #eff6ff;
}

.group:hover .group-hover\:text-blue-500 {
  color: #3b82f6;
}
</style>